// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class IntegrationSummary {
  readonly id: string;
  readonly name: string;
  readonly integrationType: Enums.IntegrationType;
  readonly externalIdentifier: string;
  readonly isActive: boolean;
  readonly isArchived: boolean;
  readonly exportQuotes: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.integrationType =
      data.integrationType === undefined ? Enums.IntegrationType.Series : data.integrationType;
    this.externalIdentifier = data.externalIdentifier === undefined ? '' : data.externalIdentifier;
    this.isActive = data.isActive === undefined ? false : data.isActive;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
    this.exportQuotes = data.exportQuotes === undefined ? false : data.exportQuotes;
  }

  static zero(): IntegrationSummary {
    const zeroValues: ExcludeMethodsDeep<IntegrationSummary> = {
      id: NIL_UUID,
      name: '',
      integrationType: Enums.IntegrationType.Series,
      externalIdentifier: '',
      isActive: false,
      isArchived: false,
      exportQuotes: false,
    };
    return new IntegrationSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type IntegrationSummaryWireFormat = {
  id: string;
  name: string;
  integrationType: string;
  externalIdentifier: string;
  isActive: boolean;
  isArchived: boolean;
  exportQuotes: boolean;
};

type NewIntegrationSummaryProps = PartialDeep<IntegrationSummary, { recurseIntoArrays: true }>;
export const NewIntegrationSummary: (props: NewIntegrationSummaryProps) => IntegrationSummary = (
  props,
) => new IntegrationSummary(props);

type NewIntegrationSummaryFromWireFormatProps = PartialDeep<
  IntegrationSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewIntegrationSummaryFromWireFormat: (
  props: NewIntegrationSummaryFromWireFormatProps,
) => IntegrationSummary = (props) => new IntegrationSummary(props);
